<!-- wallet-summary.component.html -->

<div class="wallet-summary-container" *ngIf="!hasError; else errorTpl">
    <div *ngIf="isLoading" class="loading-state">
      <p>Loading...</p>
    </div>
  
    <div *ngIf="!isLoading">
      <!-- Positive or Negative Earn Alerts -->
      <div *ngIf="positiveEarn" class="alert alert-positive">
        Earned up to <span class="text-green">{{ earnUptoText }}</span>
      </div>
      <div *ngIf="negativeEarn" class="alert alert-negative">
        Dropped by <span class="text-red">{{ earnUptoText }}</span>
      </div>
  
      <div class="chart-wrapper">
        <canvas
          baseChart
          [data]="lineChartData"
          [type]="lineChartType"
          [options]="lineChartOptions"
        >
        </canvas>
      </div>
    </div>
  </div>
  
  <ng-template #errorTpl>
    <div class="error-msg">
      <p>Something went wrong fetching wallet data.</p>
    </div>
  </ng-template>
  